// MoneyPacks.js
// In-app purchase cash packs for Steam IAP

export const MONEY_PACKS = [
  {
    id: 'seed_money',
    itemdefid: 1001,  // Steam Inventory itemdefid
    name: 'Seed Money',
    cashAmount: 50_000_000,
    wingsAmount: 10,
    priceUSD: 2.99,
    description: 'Get started with a solid foundation'
  },
  {
    id: 'regional_boost',
    itemdefid: 1002,
    name: 'Regional Boost',
    cashAmount: 120_000_000,
    wingsAmount: 25,
    priceUSD: 4.99,
    description: 'Expand your regional network'
  },
  {
    id: 'expansion_fund',
    itemdefid: 1003,
    name: 'Expansion Fund',
    cashAmount: 300_000_000,
    wingsAmount: 60,
    priceUSD: 9.99,
    description: 'Fund your next big expansion'
  },
  {
    id: 'tycoon_pack',
    itemdefid: 1004,
    name: 'Tycoon Pack',
    cashAmount: 800_000_000,
    wingsAmount: 150,
    priceUSD: 19.99,
    description: 'Serious capital for serious growth'
  },
  {
    id: 'empire_builder',
    itemdefid: 1005,
    name: 'Empire Builder',
    cashAmount: 1_500_000_000,
    wingsAmount: 400,
    priceUSD: 39.99,
    bestValue: true,
    description: 'Build your aviation empire'
  },
];

// Map itemdefid to pack for inventory sync
export const ITEMDEF_TO_PACK = MONEY_PACKS.reduce((acc, pack) => {
  acc[pack.itemdefid] = pack;
  return acc;
}, {});

// Helper to format cash amounts
export function formatCashAmount(amount) {
  if (amount >= 1_000_000_000) {
    return `$${(amount / 1_000_000_000).toFixed(1)}B`;
  }
  return `$${(amount / 1_000_000).toFixed(0)}M`;
}

// Calculate $/million for display
export function getDollarPerMillion(pack) {
  const millions = pack.cashAmount / 1_000_000;
  return (pack.priceUSD / millions).toFixed(3);
}
